@if (allowPricingLink) {
  @if (productName() === 'enterprise') {
    <a
      [routerLink]="productName() === 'enterprise' ? '/enterprise' : '/a/checkout/' + productName()"
      (click)="closeDialogs()"
    >
      <ng-container *ngTemplateOutlet="template"></ng-container>
    </a>
  } @else {
    <div (click)="badgeClick()">
      <ng-container *ngTemplateOutlet="template"></ng-container>
    </div>
  }

  <ng-template #template>
    <app-badge
      icon="/assets/icons/up-arrow.svg"
      [color]="badgeColor()"
      [interactable]="true"
      [appTooltip]="text"
      [skipDelay]="true"
      appClickTrack
      name="upgrade-badge"
      [location]="location"
      [extra]="{ scope, upgradeProduct: productName(), currentProduct }"
    >
      {{ productName() | productNameShort }}
    </app-badge>
  </ng-template>
} @else {
  <app-badge
    icon="/assets/icons/up-arrow.svg"
    [color]="badgeColor()"
    [interactable]="true"
    [appTooltip]="'Ask an admin to upgrade to use this feature'"
    [skipDelay]="true"
  >
    {{ productName() | productNameShort }}
  </app-badge>
}
